function safeJsonParse(str) {
    var defaultValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    // Quick check for easier debugging... and performance I guess
    if (!str || typeof str !== "string") return defaultValue;
    try {
        return JSON.parse(str);
    } catch (e) {
        return defaultValue;
    }
}
export default safeJsonParse;
